import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { OmnibusGroupDetailView } from '../components/views/omnibusGroupDetailView'

function OmnibusGroupDetail() {
    return (
        <div className="omnibusGroupDetail">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Omnibus Detail" />
                    <OmnibusGroupDetailView />
                </Page>
            </MainView>
        </div>
    )
}

export default OmnibusGroupDetail
